<template>
  <div v-if="showModuloForm === false">
    <MarketingModules></MarketingModules>
  </div>
  <div class="page" v-else-if="showModuloForm === true">
    <Panel lineColor="var(--primary-color)">
      <template v-slot:options>
        <FormButtonGroup align="end" spaced>
          <FormButtonMenu
            type="secundario"
            :options="operacoesOptions"
            @click="op => selectOperacao(op)"
            :loading="loadingAcao"
          >
            Operação em massa
          </FormButtonMenu>
        </FormButtonGroup>
      </template>
      <DataTable
        showSelect
        :headers="headers"
        :endpoint="endpoint"
        :filters="filters"
        noHideFilters
        :auto-search="false"
        sortBy="numpedido"
        :sortDesc="true"
        ref="datatable"
        @click="onClick"
        :limitPage="[5, 10, 15, 20, 25]"
        :itemsPerPage="25"
        v-model="pedidosSelecionados"
      >
        <template v-slot:numpedido="{ row }">
          <div class="font-weight-bold">{{ row.numpedido }}</div>
          <div>{{ row.datapedido | formatDateTime }}</div>
          <div v-if="row.totalliquido">
            {{ formatarTotal(row.totalliquido) | formatMoney }}
          </div>
          <div v-else>{{ 0 | formatMoney }}</div>
          <div v-if="row.id_pedido_erp">ID no erp: {{ row.id_pedido_erp }}</div>
          <div v-if="row.num_pedido_cliente">
            Nº Ped Cliente: {{ row.num_pedido_cliente }}
          </div>
        </template>
        <template v-slot:nome_cliente="{ row }">
          <div class="font-weight-bold">
            {{ row.nome_cliente }}
            <span v-if="row.id_cliente_erp">
              - Cod ERP:{{ row.id_cliente_erp }}
            </span>
          </div>
          <div>{{ row.email }}</div>
          <div>{{ row.telefone }}</div>
        </template>
        <template v-slot:forma_entrega="{ col }">
          <div class="font-weight-bold">{{ col.tipo }}</div>
          <strong>Transportadora: </strong>{{ col.nome }} <br />
          <span v-if="col.prazo">
            <strong>Prazo: </strong>{{ col.prazo }} dia(s)
          </span>
        </template>
        <template v-slot:etiqueta="{ col }">
          <FormButton
            text="Baixar"
            type="primario"
            flat
            @click="() => onClickEtiqueta(col)"
            v-if="col"
          />
        </template>
        <template v-slot:erro="{ col }">
          <v-tooltip v-if="col" top>
            <template v-slot:activator="{ on }">
              <v-icon color="red" v-on="on">fa-exclamation-circle</v-icon>
            </template>
            {{ col }}
          </v-tooltip>
        </template>
      </DataTable>
    </Panel>
    <transition name="slide-popup" mode="out-in">
      <router-view class="view" @close="onClose"></router-view>
    </transition>
  </div>
</template>

<script>
import DataTable from "@/components/DataTable";
import Panel from "@/components/Panel";
import MarketingModules from "@/components/MarketingModules";
import { mapGetters } from "vuex";
import { ModulesEnum } from "@/store/actions/modulesEnum";
import FormButton from "@/components/form/FormButton";
import { ETIQUETA_REGERAR, ETIQUETA_UF } from "@/store/actions/etiqueta";
import FormButtonGroup from "@/components/form/FormButtonGroup";
import FormButtonMenu from "@/components/form/FormButtonMenu";

export default {
  name: "EtiquetaTable",
  components: {
    DataTable,
    Panel,
    MarketingModules,
    FormButton,
    FormButtonGroup,
    FormButtonMenu
  },
  data: () => ({
    isLoading: false,
    headers: [
      { text: "Pedido", value: "numpedido" },
      { text: "Cliente", value: "nome_cliente" },
      { text: "Cidade/UF", value: "cidade_uf", align: "center" },
      { text: "Forma de entrega", value: "forma_entrega" },
      { text: "Etiqueta", value: "etiqueta", align: "center" },
      { text: "Críticas", value: "erro", align: "center" }
    ],
    loadingRow: {},
    slideStatus: [],
    modulosForm: [
      ModulesEnum.PAINEL_CLIENTE,
      ModulesEnum.ORCAMENTO_WEB,
      ModulesEnum.ORCAMENTO_APP,
      ModulesEnum.VENDAMAIS_WEB,
      ModulesEnum.VENDAMAIS_APP,
      ModulesEnum.WEB_COMMERCE,
      ModulesEnum.COMMERCE_APP
    ],
    pedidosSelecionados: [],
    operacoesOptions: [
      { text: "Regerar Etiquetas", value: "regerar_etiquetas" }
    ],
    loadingAcao: false,
    estadosOptions: ETIQUETA_UF
  }),
  computed: {
    ...mapGetters([
      "getFornecedorId",
      "moduloFornecedorAtivo",
      "getFornecedorTag"
    ]),
    filters() {
      return [
        { label: "Pedido", query: "numpedido" },
        { label: "Nome, E-mail ou Documento do cliente", query: "cliente" },
        {
          label: "Data inicial",
          query: "data_inicial",
          type: "date"
        },
        {
          label: "Data final",
          query: "data_final",
          type: "date"
        },
        {
          label: "Cidade",
          query: "cidade"
        },
        {
          label: "Estado",
          query: "uf",
          default: "",
          clearable: "true",
          options: this.estadosOptions
        },
        {
          label: "Forma de pagamento",
          query: "formapagamento",
          type: "autocomplete",
          multiple: true,
          request: {
            value: "idformapagto",
            text: "description",
            endpoint: `/api/v4/payment-method/${this.getFornecedorId}`,
            query: "search"
          }
        }
      ];
    },
    endpoint() {
      return `/api/v4/etiqueta/listForTable/${this.getFornecedorId}`;
    },
    showModuloForm() {
      return this.moduloFornecedorAtivo(this.modulosForm);
    }
  },
  methods: {
    selectOperacao(option) {
      const edicaoPlanilha = option.value.startsWith("planilha");
      if (edicaoPlanilha) {
        this.modalEdicaoEmPlanilha = {
          open: true,
          modelo: option.value
        };
        return;
      }
      if (this.pedidosSelecionados.length == 0) {
        this.$vueOnToast.pop(
          "warning",
          "Necessário selecionar ao menos um pedido para aplicar operações em massa"
        );
        return;
      }
      switch (option.value) {
        case "regerar_etiquetas":
          this.regerarEtiquetas();
          break;
      }
    },
    onClick(row, col) {
      let url = null;

      switch (col.value) {
        case "numpedido":
          url = this.$router.resolve({
            path: `/fornecedor/pedidos/detalhes/${row.numpedido}`
          }).href;
          break;
        case "nome_cliente":
          url = this.$router.resolve({
            path: `/fornecedor/cadastro/cliente/${row.idcliente}`
          }).href;
          break;
        default:
          return;
      }

      window.open(url, "_blank");
    },
    onClickEtiqueta(url) {
      window.open(url, "_blank");
    },
    onClose() {
      this.$refs.datatable.reload();
      this.loadingRow = {};
    },
    regerarEtiquetas() {
      this.loadingAcao = true;
      const arrayFormasEntrega = [];

      this.pedidosSelecionados.forEach(pedido => {
        const formaEntrega = {
          ...pedido.forma_entrega,
          idpedido: pedido.idpedido
        };
        arrayFormasEntrega.push(formaEntrega);
      });

      this.$store
        .dispatch(ETIQUETA_REGERAR, { arrayFormasEntrega })
        .then(() => {
          this.loadingAcao = false;

          this.$vueOnToast.pop(
            "success",
            "Etiquetas geradas para os pedidos selecionados com sucesso!"
          );

          setTimeout(() => {
            window.location.reload();
          }, 1500);
        })
        .catch(() => (this.loadingAcao = false));
    },
    formatarTotal(valor) {
      if (!valor) return 0;
      const numero = parseFloat(valor);
      if (isNaN(numero)) return 0;
      return numero.toFixed(2);
    }
  }
};
</script>
